"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDocumentAuditCertificationComparisonDto = instanceOfDocumentAuditCertificationComparisonDto;
exports.DocumentAuditCertificationComparisonDtoFromJSON = DocumentAuditCertificationComparisonDtoFromJSON;
exports.DocumentAuditCertificationComparisonDtoFromJSONTyped = DocumentAuditCertificationComparisonDtoFromJSONTyped;
exports.DocumentAuditCertificationComparisonDtoToJSON = DocumentAuditCertificationComparisonDtoToJSON;
exports.DocumentAuditCertificationComparisonDtoToJSONTyped = DocumentAuditCertificationComparisonDtoToJSONTyped;
const DocumentAuditComparisonExtractedCertificationDto_1 = require("./DocumentAuditComparisonExtractedCertificationDto");
const DocumentAuditComparisonClaimedCertificationDto_1 = require("./DocumentAuditComparisonClaimedCertificationDto");
/**
 * Check if a given object implements the DocumentAuditCertificationComparisonDto interface.
 */
function instanceOfDocumentAuditCertificationComparisonDto(value) {
    if (!('typeMatched' in value) || value['typeMatched'] === undefined)
        return false;
    if (!('expirationMatched' in value) || value['expirationMatched'] === undefined)
        return false;
    if (!('claimed' in value) || value['claimed'] === undefined)
        return false;
    if (!('extracted' in value) || value['extracted'] === undefined)
        return false;
    return true;
}
function DocumentAuditCertificationComparisonDtoFromJSON(json) {
    return DocumentAuditCertificationComparisonDtoFromJSONTyped(json, false);
}
function DocumentAuditCertificationComparisonDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'typeMatched': json['typeMatched'],
        'expirationMatched': json['expirationMatched'],
        'claimed': (0, DocumentAuditComparisonClaimedCertificationDto_1.DocumentAuditComparisonClaimedCertificationDtoFromJSON)(json['claimed']),
        'extracted': (0, DocumentAuditComparisonExtractedCertificationDto_1.DocumentAuditComparisonExtractedCertificationDtoFromJSON)(json['extracted']),
    };
}
function DocumentAuditCertificationComparisonDtoToJSON(json) {
    return DocumentAuditCertificationComparisonDtoToJSONTyped(json, false);
}
function DocumentAuditCertificationComparisonDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'typeMatched': value['typeMatched'],
        'expirationMatched': value['expirationMatched'],
        'claimed': (0, DocumentAuditComparisonClaimedCertificationDto_1.DocumentAuditComparisonClaimedCertificationDtoToJSON)(value['claimed']),
        'extracted': (0, DocumentAuditComparisonExtractedCertificationDto_1.DocumentAuditComparisonExtractedCertificationDtoToJSON)(value['extracted']),
    };
}
//# sourceMappingURL=DocumentAuditCertificationComparisonDto.js.map